import React from 'react';
import styles from './PercentSection.styles';

const PercentSection = ({ props: { value, unit, text, color } }) => (
  <div css={styles(color)}>
    <div className="percent-container">
      <p className="percent">{value}</p>
      <p className="unit">{unit}</p>
    </div>
    <p className="percent-text">{text}</p>
  </div>
);

export default PercentSection;
